import { publicRoutes, protectedRoutes } from '@/configs/routes.config'

export const getMatchedRoute = (pathname: string) => {
    // Combine all routes
    const allRoutes = [...publicRoutes, ...protectedRoutes]

    // Find the first route that matches the pathname
    return allRoutes.find((route) => {
        // Simple exact match for now
        return route.path === pathname
    })
}

export const hasPermission = (
    routeRequiredPermission: string[] = [],
    userAuthority: string[] = [],
) => {
    // If route doesn't require any permission, allow access
    if (routeRequiredPermission.length === 0) {
        return true
    }

    // Check if user has any of the required permissions
    return routeRequiredPermission.some((permission) =>
        userAuthority.includes(permission),
    )
}
